import { useNavigate } from 'react-router-dom';
import { humanize } from '@/lib/humanize';
import { getArtifactTypes } from '@/lib/filters';

export default function PaperCard({ paper, artifactColors, compareMode = false, selected = false, onToggleCompare }) {
  const navigate = useNavigate();
  const { metadata, contribution } = paper;
  const artifactTypes = getArtifactTypes(paper);
  const keywords = contribution?.keywords || [];
  const goal = contribution?.focus_intent?.goal_paper;

  const handleActivate = () => {
    if (compareMode) onToggleCompare?.(paper._id);
    else navigate(`/papers/${paper._id}`);
  };

  return (
    <article
      className={`paper-card ${selected ? 'paper-card--selected' : ''} ${paper._userAdded ? 'paper-card--user-added' : ''}`}
      onClick={handleActivate}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleActivate();
        }
      }}
      tabIndex={0}
      role="button"
    >
      {compareMode && (
        <div className={`paper-card__checkbox ${selected ? 'paper-card__checkbox--checked' : ''}`}>
          {selected && '✓'}
        </div>
      )}
      {paper._userAdded && <span className="user-added-badge">+ Added by you</span>}
      <div className="paper-card__badges">
        {artifactTypes.map((t) => (
          <span key={t} className="paper-card__badge" style={{ '--inquiry-color': artifactColors[t] }}>
            {humanize(t)}
          </span>
        ))}
      </div>
      <h3 className="paper-card__title">{metadata.title}</h3>
      <p className="paper-card__meta">
        {metadata.authors?.join(', ')} · {metadata.year} · {metadata.track}
      </p>
      {goal && <p className="paper-card__goal">{goal}</p>}
      {keywords.length > 0 && (
        <div className="paper-card__keywords">
          {keywords.slice(0, 6).map((k) => (
            <span key={k} className="chip chip--sm">{k}</span>
          ))}
        </div>
      )}
    </article>
  );
}
